jQuery( document ).ready( function() {
	// Function to send AJAX request for posts based on selected category and search
	function sendAjaxRequestForPosts( selectedCategory, search ) {
		// Make AJAX request to fetch posts based on the selected category and search
		jQuery.ajax( {
			url: localVars.ajax_url,
			type: 'POST',
			data: {
				action: 'filter_posts',
				category: selectedCategory,
				search,
			},
			success( response ) {
				if ( response ) {
					// Update the posts container with the new posts
					jQuery( '.blog-posts.resources-posts.search-result-posts' ).html( response );
				}
			},
		} );
	}

	// Event listener for form submission
	// jQuery( '#searchform' ).on( 'submit', function( e ) {
	// 	e.preventDefault(); // Prevent the default form submission

	// 	// Get the selected category and search value
	// 	const selectedCategory = jQuery( '.select-dropdown__list-title' ).data( 'category' );
	// 	const search = jQuery( '#ajax-search-value' ).val();

	// 	// Call the function to send AJAX request for posts
	// 	sendAjaxRequestForPosts( selectedCategory, search );
	// } );
} );
